import { render, staticRenderFns } from "./idCardInfo.vue?vue&type=template&id=2ab0df42&scoped=true"
import script from "./idCardInfo.vue?vue&type=script&lang=js"
export * from "./idCardInfo.vue?vue&type=script&lang=js"
import style0 from "./idCardInfo.vue?vue&type=style&index=0&id=2ab0df42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0df42",
  null
  
)

export default component.exports